import { motion } from "framer-motion";

export default function LogoEmblem({ size = 200, animated = false }) {
  const draw = (delay, duration = 0.9) =>
    animated
      ? { initial: { pathLength: 0 }, animate: { pathLength: 1 }, transition: { delay, duration, ease: "easeInOut" } }
      : {};
  const fade = (delay) =>
    animated ? { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { delay, duration: 0.5 } } : {};
  const small = size < 64;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      fill="none"
      data-testid="brand-logo"
      role="img"
      aria-label="NB Couverture"
    >
      <defs>
        <linearGradient id="nbe-terra" x1="0" y1="0" x2="200" y2="200" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E87A52" />
          <stop offset="1" stopColor="#C2552F" />
        </linearGradient>
      </defs>
      <motion.circle cx="100" cy="100" r="96" fill="#14171D" {...fade(0)} />
      <motion.circle cx="100" cy="100" r="96" stroke="url(#nbe-terra)" strokeWidth="4" {...draw(0.1, 1.1)} />
      <motion.circle cx="100" cy="100" r="84" stroke="#D4AF37" strokeWidth="1" opacity="0.5" {...draw(0.3, 1)} />
      <motion.rect x="126" y="56" width="9" height="18" fill="url(#nbe-terra)" {...fade(0.9)} />
      <motion.path
        d="M48 92 L100 52 L152 92"
        stroke="url(#nbe-terra)"
        strokeWidth="7"
        strokeLinecap="square"
        {...draw(0.5, 0.8)}
      />
      <motion.text
        x="100"
        y={small ? 142 : 138}
        textAnchor="middle"
        fontFamily="Playfair Display, Georgia, serif"
        fontWeight="700"
        fontSize={small ? 64 : 56}
        fill="#F8FAFC"
        {...fade(0.8)}
      >
        NB
      </motion.text>
      {!small && (
        <>
          <motion.rect x="70" y="150" width="60" height="2" fill="#D4AF37" {...fade(1.1)} />
          <motion.text
            x="100"
            y="170"
            textAnchor="middle"
            fontFamily="JetBrains Mono, monospace"
            fontSize="10"
            letterSpacing="3"
            fill="#94A3B8"
            {...fade(1.2)}
          >
            COUVERTURE
          </motion.text>
        </>
      )}
    </svg>
  );
}
